import guestId from "./guestId";

const addGid = (url) => `${url}${guestId() ? `?gid=${guestId()}` : ""}`;

const cartRoutes = {
  cartUrl: addGid(`/a/cart`),
  cartAddUrl: addGid(`/a/cart/add`),
  cartUpdateUrl: addGid(`/a/cart/update`),
  cartChangeUrl: addGid(`/a/cart/change`),
  cartClearUrl: addGid(`/a/cart/clear`),
  saveQuoteUrl: "/a/cart/save-quote", // does not require Gid
};

export default cartRoutes;
